<template>
  <div id="Service" class="advantage-page">
    <div class="container">
      <!-- 眉标 + 主标题：沿用全站 .section-title 规范；primary1 = 品牌主色玫红
           （本页为独立页面、原蓝 #28f 装饰色与全站冲突，统一归位品牌色） -->
      <div
        class="section-title primary1 text-center wow fadeInUp"
        data-wow-duration="1.5s"
        data-wow-delay="0.05s"
      >
        <span>-我们的优势是什么？-</span>
        <h3>我们的优势</h3>
      </div>

      <div class="adv-grid">
        <div
          class="adv-card wow fadeInUp"
          v-for="(item, index) in serviceList"
          :key="item.id"
          data-wow-duration="1.2s"
          :data-wow-delay="0.12 * (index + 1) + 's'"
          @click="ServiceClick(item.id)"
        >
          <div class="adv-media">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="adv-body">
            <h4 class="adv-title">{{ item.title }}</h4>
            <p class="adv-en">{{ item.eng_title }}</p>
            <span class="adv-line"></span>
            <p class="adv-desc">{{ item.desc }}</p>
            <!-- <span class="adv-more">了解详情<span class="adv-arrow"></span></span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "Service",
  data() {
    return {
      serviceList: [
        {
          id: "section-1",
          title: "高效的服务能力",
          eng_title: "Efficient Service Capability",
          desc: "需求快速响应，问题定点解决，实施节奏按客户实际场景灵活调整",
          img: require("@/assets/images/pic21.png"),
        },
        {
          id: "section-2",
          title: "资深的行业专家经验",
          eng_title: "Professional Industry Experts",
          desc: "深耕医疗与政务信息化多年，行业顾问全程参与需求梳理与方案设计",
          img: require("@/assets/images/pic22.png"),
        },
        {
          id: "section-3",
          title: "先进的技术应用架构",
          eng_title: "Advanced Technology Architecture",
          desc: "微服务架构，配套统一数据中台与智能分析能力，便于扩展与系统对接",
          img: require("@/assets/images/pic23.png"),
        },
        {
          id: "section-4",
          title: "完备的交付体系",
          eng_title: "Complete Delivery System",
          desc: "分阶段确认、持续迭代交付，关键节点评审留痕，变更全程可追溯",
          img: require("@/assets/images/pic24.png"),
        },
      ],
    };
  },
  mounted() {
    var wow = new WOW();
    wow.init();
  },
  methods: {
    ServiceClick(id) {
      this.$router.push({
        name: "servicedetail",
        params: {
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
/* 页面纵向节奏：与 Header 留白 + 与 Footer 拉开呼吸感 */
.advantage-page {
  padding: 70px 0 90px;
  background: #ffffff;
}

/* ===== 卡片网格 ===== */
.adv-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  justify-content: center;
  align-items: stretch;
}

.adv-card {
  flex: 1 1 calc(25% - 28px);
  max-width: 292px;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #eceef2;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 10px rgba(16, 24, 40, 0.03);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275),
    box-shadow 0.4s ease, border-color 0.4s ease;
}

/* 顶部玫红进度条：hover 时从左铺满 */
.adv-card::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 3px;
  background: #e6004c;
  transition: width 0.45s ease;
  z-index: 3;
}

.adv-card:hover::after {
  width: 100%;
}

.adv-card:hover {
  transform: translateY(-8px);
  border-color: rgba(230, 0, 76, 0.28);
  box-shadow: 0 18px 38px rgba(16, 24, 40, 0.1);
}

/* ===== 图片区：固定比例 + 中心裁切（老内核不用 aspect-ratio） ===== */
.adv-media {
  position: relative;
  width: 100%;
  padding-top: 76%;
  overflow: hidden;
  background: #f5f6f8;
}

.adv-media img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.6s ease;
}

.adv-card:hover .adv-media img {
  transform: scale(1.06);
}

/* ===== 信息区 ===== */
.adv-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 22px 22px 24px;
  text-align: center;
}

.adv-title {
  font-size: 19px;
  font-weight: 600;
  color: #1d2b48;
  line-height: 1.45;
  margin: 0 0 8px;
  transition: color 0.3s ease;
}

.adv-card:hover .adv-title {
  color: #e6004c;
}

.adv-en {
  font-family: poppins, sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #9aa3b2;
  line-height: 1.5;
  margin: 0 0 12px;
}

/* 玫红短线：标题区与描述区的分隔（原为蓝色 #28f，改为品牌色） */
.adv-line {
  display: inline-block;
  width: 26px;
  height: 3px;
  border-radius: 2px;
  background: #e6004c;
  margin: 0 auto 14px;
  transition: width 0.45s ease;
}

.adv-card:hover .adv-line {
  width: 42px;
}

.adv-desc {
  font-size: 13px;
  line-height: 1.75;
  color: #676767;
  margin: 0;
}

/* 可点击提示 */
.adv-more {
  display: inline-block;
  margin-top: auto;
  padding-top: 16px;
  font-size: 12px;
  color: #9aa3b2;
  transition: color 0.3s ease;
}

.adv-arrow {
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-left: 6px;
  margin-bottom: 2px;
  border-top: 1.5px solid currentColor;
  border-right: 1.5px solid currentColor;
  transform: rotate(45deg);
  vertical-align: middle;
  transition: transform 0.3s ease;
}

.adv-card:hover .adv-more {
  color: #e6004c;
}

.adv-card:hover .adv-arrow {
  transform: rotate(45deg) translate(2px, -2px);
}

/* ===== 响应式：平板两列、手机单列 ===== */
@media (max-width: 1199px) {
  .adv-card {
    flex: 1 1 calc(50% - 28px);
    max-width: 360px;
  }
}

@media (max-width: 767px) {
  .advantage-page {
    padding: 50px 0 60px;
  }

  .adv-grid {
    gap: 20px;
  }

  .adv-card {
    flex: 1 1 100%;
    max-width: 420px;
  }

  .adv-body {
    padding: 20px 18px 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/advantage.vue